import { Routes } from '@angular/router';
import { ProcessCheckoutComponent } from './components/process-checkout/process-checkout.component';
import { ProcessErrorComponent } from './components/process-error/process-error.component';
import { ProcessSuccessComponent } from './components/process-success/process-success.component';
import { OtpComponent } from './components/otp/otp.component';
import { LandingComponent } from './components/landing/landing.component';
import { otpGuard, processCheckoutGuard } from './guards/guards';

export const routes: Routes = [
    { path: '', redirectTo: 'landing', pathMatch: 'full' },
    { path: 'landing', component: LandingComponent },
    { path: 'otp', canActivate: [otpGuard] ,component: OtpComponent },
    { path: 'process-checkout', canActivate: [processCheckoutGuard], component: ProcessCheckoutComponent },
    { path: 'process-error', component: ProcessErrorComponent },
    { path: 'process-success', component: ProcessSuccessComponent },
    { path: '**', redirectTo: 'process-error' }
];
